// ViewCoursesLink — the one "View courses" button shown with every "payment confirmed" message.
import { Link } from "react-router-dom";

interface ViewCoursesLinkProps {
  onClick?: (() => void) | undefined;   // e.g. dismiss the banner it sits in
}

export default function ViewCoursesLink({ onClick }: ViewCoursesLinkProps) {
  return (
    <Link
      to="/app/student/courses"
      onClick={onClick}
      className="inline-block rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-green-700"
    >
      View courses
    </Link>
  );
}
